import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PRICE_ARS } from '../data/config';
import { CTAButton } from './Shared';

/** Barra de compra fija en celular: aparece al dejar atrás el hero y se oculta sobre el pie de página. */
export function MobileBuyBar() {
  const [heroPassed, setHeroPassed] = useState(false);
  const [footerVisible, setFooterVisible] = useState(false);
  useEffect(() => {
    const hero = document.getElementById('hero');
    const footer = document.getElementById('pie');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === hero) setHeroPassed(!entry.isIntersecting && entry.boundingClientRect.top < 0);
        if (entry.target === footer) setFooterVisible(entry.isIntersecting);
      });
    });
    if (hero) observer.observe(hero);
    if (footer) observer.observe(footer);
    return () => observer.disconnect();
  }, []);
  const visible = heroPassed && !footerVisible;
  return <AnimatePresence data-id="element-190" data-mp="1bhtm3bns1ak">
      {visible && <motion.div initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-brand-violet/10 bg-white shadow-bar md:hidden" style={{
      paddingBottom: 'calc(0.75rem + env(safe-area-inset-bottom))'
    }} data-id="element-191" data-mp="1ex8p65c1abz">
          
        </motion.div>}
    </AnimatePresence>;
}